module.exports = __webpack_public_path__ + "img/p3.4eab2d76.png";